"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Texture_1 = require("../../tree/Texture");
const TextTextureRenderer_1 = require("./TextTextureRenderer");
const Utils_1 = require("../../tree/Utils");
class TextTexture extends Texture_1.Texture {
    constructor(stage) {
        super(stage);
        this.settings = {};
        this._text = "";
        this.pixelRatio = this.stage.pixelRatio;
    }
    setSettings(settings) {
        this.settings = settings;
        this._changed();
    }
    get text() {
        return this._text;
    }
    set text(v) {
        if (this._text !== v) {
            this._text = v;
            this._changed();
        }
    }
    get fontWeight() {
        return this.settings.fontWeight;
    }
    set fontWeight(v) {
        if (this.settings.fontWeight !== v) {
            this.settings.fontWeight = v;
            this._changed();
        }
    }
    get fontStyle() {
        return this.settings.fontStyle;
    }
    set fontStyle(v) {
        if (this.settings.fontStyle !== v) {
            this.settings.fontStyle = v;
            this._changed();
        }
    }
    get fontSize() {
        return this.settings.fontSize;
    }
    set fontSize(v) {
        if (this.settings.fontSize !== v) {
            this.settings.fontSize = v;
            this._changed();
        }
    }
    get fontFace() {
        return this.settings.fontFace;
    }
    set fontFace(v) {
        if (this.settings.fontFace !== v) {
            this.settings.fontFace = v;
            this._changed();
        }
    }
    get cutSx() {
        return this.settings.cutSx;
    }
    set cutSx(v) {
        if (this.settings.cutSx !== v) {
            this.settings.cutSx = v;
            this._changed();
        }
    }
    get cutEx() {
        return this.settings.cutEx;
    }
    set cutEx(v) {
        if (this.settings.cutEx !== v) {
            this.settings.cutEx = v;
            this._changed();
        }
    }
    get cutSy() {
        return this.settings.cutSy;
    }
    set cutSy(v) {
        if (this.settings.cutSy !== v) {
            this.settings.cutSy = v;
            this._changed();
        }
    }
    get cutEy() {
        return this.settings.cutEy;
    }
    set cutEy(v) {
        if (this.settings.cutEy !== v) {
            this.settings.cutEy = v;
            this._changed();
        }
    }
    get pixelRatio() {
        return super.pixelRatio;
    }
    set pixelRatio(v) {
        // We actually draw differently when the pixel ratio changes.
        if (this.pixelRatio !== v) {
            super.pixelRatio = v;
            this._changed();
        }
    }
    _getIsValid() {
        return !!this._text;
    }
    _getLookupId() {
        return "TX$" + this.text + "|" + Texture_1.Texture.getLookupIdFromSettings(this.settings) + "|" + this.pixelRatio;
    }
    _getSourceLoader() {
        const args = this.cloneArgs();
        return (cb) => {
            const canvas = this.stage.platform.getDrawingCanvas();
            const renderer = new TextTextureRenderer_1.TextTextureRenderer(this.stage, canvas, this.text, args, this.pixelRatio);
            const p = renderer.draw();
            const respond = () => {
                cb(undefined, Object.assign({ renderInfo: renderer.renderInfo }, this.stage.platform.getTextureOptionsForDrawingCanvas(canvas)));
            };
            if (p) {
                p.then(() => {
                    respond();
                }).catch((err) => {
                    cb(err);
                });
            }
            else {
                respond();
            }
        };
    }
    getNonDefaults() {
        const nonDefaults = super.getNonDefaults();
        for (const [key, value] of Object.entries(this.settings)) {
            nonDefaults[key] = value;
        }
        return nonDefaults;
    }
    cloneArgs() {
        return Utils_1.Utils.clone(this.settings);
    }
}
exports.TextTexture = TextTexture;
//# sourceMappingURL=TextTexture.js.map